import request from '@/utils/request'


// 获取合同空间banner
export function listLaunch(data) {
    return request({
        url: '/api/common/v1/process/listLaunch',
        method: 'post',
        data
    })
}

export function listLaunchApi(data) {
    return request({
        url: '/api/common/v1/process/listLaunch',
        method: 'post',
        data
    })
}

export function listCheckApi(data) {
    return request({
        url: '/api/common/v1/process/listCheck',
        method: 'post',
        data
    })
}

// export const listLaunchApiUrl = '/api/common/v1/process/listLaunch';

// export const listCheckApiUrl = '/api/common/v1/process/listCheck';

// 获取流程详情
export function getProcessInfo(data) {
    return request({
        url: '/api/common/v1/process/getProcessInfo',
        method: 'post',
        data: data
    })
}

// 审批
export function submitCheck(data) {
    return request({
        url: '/api/common/v1/process/submitCheck',
        method: 'post',
        data: data
    })
}

// 撤回流程
export function recallProcess(data) {
    return request({
        url: '/api/common/v1/process/recallProcess',
        method: 'post',
        data: data
    })
}

